import logger from '%app/js/common/services/Logger';
import parseJsonAttribute from '%app/js/common/services/parseJsonAttribute';

const REDESIGN_ROOT_ID = 'redesign-root';
const REDESIGN_HEADER_ROOT_ID = 'redesign-header-root';
const REDESIGN_FOOTER_ROOT_ID = 'redesign-footer-root';
const REDESIGN_NOT_FOUND_ROOT_ID = 'redesign-not-found-root';

const DEFAULT_ELEMENT_IDS = [REDESIGN_ROOT_ID, REDESIGN_HEADER_ROOT_ID, REDESIGN_FOOTER_ROOT_ID];

function findRoot(elementId) {
    if (typeof document === 'undefined') {
        return null;
    }

    if (elementId) {
        return document.getElementById(elementId);
    }

    return DEFAULT_ELEMENT_IDS
        .map(id => document.getElementById(id))
        .find(Boolean) || null;
}

function readRedesignRootAttribute(attributeName, elementId) {
    return parseJsonAttribute(
        findRoot(elementId),
        attributeName,
        {},
        error => logger.error('Failed to parse redesign root attribute', { attributeName, error }),
    );
}

function removeRedesignRootAttribute(attributeName, elementId) {
    const root = findRoot(elementId);
    if (root) {
        root.removeAttribute(attributeName);
    }
}

export default readRedesignRootAttribute;
export {
    removeRedesignRootAttribute,
    REDESIGN_ROOT_ID,
    REDESIGN_HEADER_ROOT_ID,
    REDESIGN_FOOTER_ROOT_ID,
    REDESIGN_NOT_FOUND_ROOT_ID,
};
